import {
  createEvoClient,
  findActionVerificationItem,
  initRegistration,
  verifyActionVerification,
} from "@jti/evo-client";
import type { OtpChannel } from "@jti/fe-common";
import type { PhoneValidationInitResponse, PvsApiContract, PvsResponse, StatusResponse } from "@jti/rest-api-types";

import { getUser } from "../../../utils";
import { getIsStatusValidated } from "../utils";

const PHONE_VERIFICATION_CHANNEL = "sms";

export class PvsApiEvo implements PvsApiContract {
  private readonly client;
  constructor(baseUrl: string, tenantToken: string, recaptchaId: string) {
    const user = getUser();
    this.client = createEvoClient({
      baseUrl,
      tenantToken,
      recaptchaId,
      ciamToken: user.ciam_token,
      throwOnError: true,
    });
  }

  async initPhoneValidationByOtp(
    phone: string,
    otpChannel: OtpChannel = "sms",
    otpTemplate: string | null = null
  ): Promise<PhoneValidationInitResponse> {
    const { data } = await initRegistration({
      client: this.client,
      body: {
        channel: otpChannel || PHONE_VERIFICATION_CHANNEL,
        identifier: phone,
        template: otpTemplate,
      },
    });

    return {
      uuid: data?.data?.uuid ?? "",
      hash: "", // hash is not longer required
    };
  }

  async verifyOtp(phoneVerificationUuid: string, code: string): Promise<PvsResponse> {
    const { data, response } = await verifyActionVerification({
      client: this.client,
      path: {
        uuid: phoneVerificationUuid,
      },
      body: {
        code,
      },
    });

    return {
      uuid: data?.data?.uuid ?? "",
      statusCode: response.status,
      is_verified: getIsStatusValidated(data?.data?.status),
      verification_performed: true,
    };
  }

  /***
   * @deprecated
   * only used in the dead code at this point in time - might be removed in the future
   */
  async verifyEmailOtp(uuid: string, code: string): Promise<PvsResponse> {
    const { data, response } = await verifyActionVerification({
      client: this.client,
      path: {
        uuid,
      },
      body: {
        code,
      },
    });

    return {
      uuid: data?.data?.uuid ?? "",
      statusCode: response.status,
      is_verified: getIsStatusValidated(data?.data?.status),
      verification_performed: true,
    };
  }

  async checkVerificationStatus(uuid: string): Promise<StatusResponse> {
    const { data } = await findActionVerificationItem({
      client: this.client,
      path: {
        uuid,
      },
    });

    return {
      uuid: data?.data?.uuid ?? "",
      is_verified: getIsStatusValidated(data?.data?.status),
      verification_sent: true,
    };
  }
}
